import { render } from "./business-card-modal.vue?vue&type=template&id=1dfcd32f&scoped=true"
import script from "./business-card-modal.vue?vue&type=script&lang=js"
export * from "./business-card-modal.vue?vue&type=script&lang=js"

import "./business-card-modal.vue?vue&type=style&index=0&id=1dfcd32f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dfcd32f"]])

export default __exports__